import React from 'react';
import {
    Button,
    message,
    Popconfirm,
} from 'antd';
import {
    FaTrashAlt
} from "react-icons/fa";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function DeletePopupButton({ data, orderId, orderItems, form }) {

    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: (info) => {
            axios
                .delete(`/api/orderItems/${data._id}`)
                .then(() => {
                    const preOrderItems = orderItems.filter(f => f._id !== info._id);
                    const grand_total = preOrderItems.reduce((prev, cur) => prev + (cur.price * cur.quantity), 0);
                    let total = grand_total;
                    let vat = 0;

                    if (form.getFieldValue("is_vat")) {
                        total = grand_total / 1.07;
                        vat = grand_total - total;
                    }

                    form.setFieldsValue({
                        total,
                        vat,
                        grand_total
                    });
                    queryClient.invalidateQueries([`/api/orderItems/getOrderDetail/${orderId}`]);
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        }
    });

    const confirm = (e) => mutate(data);

    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="Delete item"
                description="Confirm delete item Yes or No?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
            >
                <Button danger icon={<FaTrashAlt />} type='text' />
            </Popconfirm>
        </div>
    )
}
